import React, { useState, useEffect, useContext } from "react";
import AnlookImage from "../../../assets/images/Anlook.png";
import AnlookBanner from "../../../assets/images/carousel/anlookBanner1.png";
import AnlookLogo from "../../../assets/images/AnlookLogo (1).png";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import swal from "sweetalert";
import { use } from "react";
import { GlobalContext } from "../../Context/GlobalState";
import cogoToast from "cogo-toast";
import { BASE_URL_APISERVICES } from "../../utils/Constants";
import { RetailerApi_Endpoint } from "../../utils/RetailerApiEndpoint";
import { adminAuth } from "../../config";
const Anlook = () => {
  const { username1, password1 } = adminAuth;
  const [leads, setLeads] = useState([]);
  const history = useHistory();
  const { user } = useContext(GlobalContext);

  const handleRedirect = () => {
    history.push("/retailer/AnlookForm");
  };

  const handleRedirect1 = () => {
    history.push("/retailer/AnlookDocSubmit");
  };

  const handleRedirect2 = () => {
    history.push("/retailer/AnlookViewDoc");
  };


  const steps = [
    { label: "Onboarding", status: "In Progress" },
    { label: "Document Submission", status: "Pending" },
    { label: "Document Verification", status: "Pending" },
    { label: "Website Live", status: "Pending" },
  ];


  const getStepperStep =  (step) => {
    switch (step) {
        case "Onboarding":
            return 1;
        case "Document Submission":
            return 2;
        case "Verification":
            return 3;
        case "Live":
            return 4;
        default:
            return 1;
    }
    }

  const getAgentLeads = async () => {
    try {
      // setTransactionLoaderState(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
      );

      var raw = JSON.stringify({
        userid: user.ReferId,
        product: "Anlook",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${RetailerApi_Endpoint.GET_AGENT_LEADS}`,
        requestOptions
      );
      const data = await res.json();
      if (data.responseCode == "00") {
        // swal("Success", data.responseMessage, "success");
        cogoToast.success(data.responseMessage);
        setLeads(data.data.map((lead) =>{
            return {
                ...lead, name : `${lead.first_name} ${lead.last_name}`,
                productName: lead.requirements,
                phone: lead.phone,
                onboardingDate: lead.created_on,
                currentStep: getStepperStep(lead.step),
            }
        } ));
      } else {
        // swal("Failed", data.responseMessage, "error");
        cogoToast.error(data.responseMessage);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getAgentLeads();
  }, []);

  return (
    <div style={{ fontFamily: "Arial, sans-serif", padding: "20px" }}>
      <div
        style={{
          display: "flex",
          padding: "20px",
          border: "1px solid #E0E0E0",
          borderRadius: "10px",
          marginBottom: "20px",
          backgroundColor: "#F2FFF1",
        }}
      >
        <div style={{ flex: 1, paddingRight: "20px" }}>
          <img
            src={AnlookLogo}
            style={{
              height: "auto",
              width: "7rem",
              margin: "2px",
              marginBottom: "3px",
            }}
          />
          <div
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              marginBottom: "10px",
              marginTop: "5px",
            }}
          >
            Anlook is a WhatsApp Bulk messaging marketing tool designed to help businesses connect with their customers easily and effectively.
          </div>
          <h5><b>Earn more With Anlook</b></h5>
          <ul style={{ paddingLeft: "20px", marginBottom: "20px" }}>
            <li>Retailers will earn ₹2000 for every restaurant that pays the ₹5000 joining fee.</li>
            <li>The more you refer, the more you earn </li>
          </ul>
          <h5><b>Benefits for Clients:</b></h5>
          <ul style={{ paddingLeft: "20px", marginBottom: "20px" }}>
            <li>Boost your business with WhatsApp marketing.</li>
            <li>Connect with your customers directly and quickly on WhatsApp</li>
            <li>Simple, effective, and tailored to your needs</li>
            <li>No need for a fancy tool to send updates just use Anlook and get the job done </li>
          </ul>
          <button
            style={{
              padding: "10px 20px",
              backgroundColor: "#007BFF",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onClick={handleRedirect}
          >
            Get Started
          </button>{" "}
        </div>
        <div style={{ flex: 1, textAlign: "center" }}>
          <div style={{ backgroundColor: "#F2FFF1", borderRadius: "10px" }}>
            <img src={AnlookBanner} style={{ height: "30rem", width: "auto" }} />
          </div>
        </div>
      </div>

      <h2
        style={{ fontSize: "20px", marginBottom: "10px", marginLeft: "1rem" }}
      > <b>  Leads </b> </h2>

      <div style={{ margin: "5px" }}>
        {leads.map((user, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid #ddd",
              padding: "20px",
              marginBottom: "10px",
              borderRadius: "10px",
              backgroundColor: "#fff",
              boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
            }}
          >
            <div>
              <div>{user.name} </div>
              {/* <hr/> */}
              <p style={{ margin: "5px 0" }}>
                <strong>Product Name:</strong> {user.productName}
              </p>
              <p style={{ margin: "5px 0" }}>
                <strong>Onboarding Date:</strong> {user.onboardingDate}
              </p>
            </div>
            <div>
          {getStepperStep(user.step) === 1 || getStepperStep(user.step) === 2 ? (
            <button
              className="btn btn-block bg-primary"
              onClick={handleRedirect1}
              style={{ color: "white", border: "none" }}
            >
              Submit Document
            </button>
          ) : (
            <button
              className="btn btn-block bg-secondary"
              onClick={handleRedirect2}
              style={{ color: "white", border: "none" }}
            >
              View Document
            </button>
          )}
        </div>

            <div style={{ flex: 1, marginLeft: "20px", maxWidth: "600px" }}>
              <Stepper steps={steps} currentStep={user.currentStep} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Anlook;

const Stepper = ({ steps, currentStep }) => {
  const [progressWidth, setProgressWidth] = useState(0);

  useEffect(() => {
    const newWidth = (currentStep / (steps.length - 1)) * 100;
    setProgressWidth(newWidth);
  }, [currentStep, steps.length]);

  return (
    <div
      style={{
        padding: "20px",
        background: "#f9f9f9",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "30%",
          left: "5%",
          width: "90%",
          height: "3px",
          backgroundColor: "#ccc",
          zIndex: 0,
        }}
      ></div>

      <div
        style={{
          position: "absolute",
          top: "30%",
          left: "5%",
          width: `${progressWidth}%`,
          height: "3px",
          backgroundColor: "green",
          zIndex: 1,
          transition: "width 2s ease-in-out",
        }}
      ></div>

      {steps.map((step, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            position: "relative",
            zIndex: 2,
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor:
                currentStep > index
                  ? "green"
                  : currentStep === index
                  ? "#6a5af9"
                  : "#ccc",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontWeight: "bold",
              fontSize: "1.2rem",
              zIndex: 3,
            }}
          >
            {currentStep > index ? "✔" : currentStep === index ? "🔒" : "⬤"}
          </div>

          <span
            style={{ marginTop: "10px", fontWeight: "200", fontSize: "50" }}
          >
            {step.label}
          </span>

          <span
            style={{
              marginTop: "5px",
              fontSize: "0.8rem",
              color:
                currentStep > index
                  ? "green"
                  : currentStep === index
                  ? "#6a5af9"
                  : "#999",
              fontWeight: "500",
            }}
          >
            {currentStep > index
              ? "Completed"
              : currentStep === index
              ? "In Progress"
              : "Pending"}
          </span>
        </div>
      ))}
    </div>
  );
};